/**
 * @ignore
 */
export abstract class Synchronized {
  synchronizedAt?: Date;
}
